module.exports = [
  {
    "id": "XQq_ehIAANY01-x9",
    "uid": "bookcase",
    "type": "kiosk",
    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq_ehIAANY01-x9%22%29+%5D%5D",
    "tags": [],
    "first_publication_date": "2019-06-19T23:56:33+0000",
    "last_publication_date": "2019-07-16T01:51:28+0000",
    "slugs": [
      "bookcase"
    ],
    "linked_documents": [],
    "lang": "en-ca",
    "alternate_languages": [],
    "data": {
      "title": "Bookcase",
      "description": "<p>Explore the digital object library to learn about items made by Shingwauk students in the 1950s. </p>",
      "zoomable": "No",
      "image_map": {
        "dimensions": {
          "width": 2704,
          "height": 3472
        },
        "alt": null,
        "copyright": null,
        "url": "5e836fdb0828c4346a150040cbfb57c94a0a1714_image-map---bookcase.png"
      },
      "points_of_interest": [
        {
          "point_of_interest": {
            "id": "XQrADRIAAMhJ1-8X",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQrADRIAAMhJ1-8X%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-20T00:00:35+0000",
            "last_publication_date": "2019-07-16T01:56:35+0000",
            "slugs": [
              "bc---01---prayerbook"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "BC - 01 - Prayerbook",
              "code": 1,
              "x_coordinate": 0.352507,
              "y_coordinate": 0.305927,
              "objects": [
                {
                  "object": {
                    "id": "XQrAvhIAAFxJ1_Iq",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQrAvhIAAFxJ1_Iq%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-20T00:00:43+0000",
                    "last_publication_date": "2019-06-27T04:25:36+0000",
                    "slugs": [
                      "bc---01---prayerbook---book-of-common-prayer",
                      "bc---book-of-common-prayer---book-of-common-prayer"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "BC - 01 - Prayerbook - Book of common prayer",
                      "name": "Book of common prayer",
                      "subtitle": "<p>Book of common prayer, 1962</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/34083"
                      },
                      "description": "<p>The Book of Common Prayer is the standard book used by the Anglican Church and would have been used during services at Shingwauk.</p>",
                      "image": {
                        "dimensions": {
                          "width": 1810,
                          "height": 2496
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "c5c9057ef6d0bd10ac519ad5c5f3ac0f478c80f8_2011-009_004_006_1.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 1567
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "f37b2779e074c9fa4a26b322ee43ba6b1e7b60fd_2011-009_004_006_1.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "point_of_interest": {
            "id": "XRC2iREAACQJeLU0",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC2iREAACQJeLU0%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-24T11:39:58+0000",
            "last_publication_date": "2019-07-16T01:57:23+0000",
            "slugs": [
              "bc---02---hymnbook"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "BC - 02 - Hymnbook",
              "code": 2,
              "x_coordinate": 0.642253,
              "y_coordinate": 0.305927,
              "objects": [
                {
                  "object": {
                    "id": "XRCz_REAACQJeK3u",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRCz_REAACQJeK3u%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-24T11:29:05+0000",
                    "last_publication_date": "2019-06-27T04:27:26+0000",
                    "slugs": [
                      "bc---02---hymn-book---book-of-common-praise",
                      "bc---02---prayerbook---book-of-common-praise",
                      "bc---01---prayerbook---book-of-common-praise"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "BC - 02 - Hymn Book - Book of common praise",
                      "name": "Book of common praise",
                      "subtitle": "<p>Book of common praise, ca. 1950</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/34084"
                      },
                      "description": "<p>This hymn book was used at the Shingwauk Residential School during chapel services. The interior front cover of the book has a stamp which reads &quot;Shingwauk Residential School&quot;</p>",
                      "image": {
                        "dimensions": {
                          "width": 1892,
                          "height": 2328
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "b691b23bf139804c9a6c6e5c9af2eec1288b5ccb_2011-009_004_007_1.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 1398
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "566b5ace67306548fd58eea9c056299bdd0e6556_2011-009_004_007_1.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "point_of_interest": {
            "id": "XRC2uxEAACIJeLYX",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC2uxEAACIJeLYX%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-24T11:40:47+0000",
            "last_publication_date": "2019-07-16T01:58:01+0000",
            "slugs": [
              "bc---03---leaf-dish"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "BC - 03 - Leaf Dish",
              "code": 3,
              "x_coordinate": 0.353553,
              "y_coordinate": 0.429752,
              "objects": [
                {
                  "object": {
                    "id": "XRC0gxEAANwAeK63",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC0gxEAANwAeK63%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-24T11:31:18+0000",
                    "last_publication_date": "2019-06-27T04:29:54+0000",
                    "slugs": [
                      "bc---03---leaf-dish---leaf-dish"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "BC - 03 - Leaf Dish - Leaf Dish",
                      "name": "Leaf Dish",
                      "subtitle": "<p>Leaf shaped dish, 1942-1948</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/25324"
                      },
                      "description": "<p>Woodworking and arts were consistently taught at Shingwauk. From 1940 to the 1960s woodworking projects included the creation of furniture as well as smaller handicraft items. These handicraft items were often sold at local Sault Ste. Marie events. This dish is an example of one of the carved items that was made by Shingwauk students and sold locally.</p>",
                      "image": {
                        "dimensions": {
                          "width": 719,
                          "height": 426
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "f8b221c1cba0a0bab31947f8d0d8ae5e4e2c9f71_2011-5_001_052_front.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 673
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "b4d75b7728c635f95394dfe06f7de103f139e190_2011-5_001_052_front.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "point_of_interest": {
            "id": "XRC2whEAANwAeLY1",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC2whEAANwAeLY1%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-24T11:41:39+0000",
            "last_publication_date": "2019-07-16T01:58:29+0000",
            "slugs": [
              "bc---04---plaque",
              "bc---03---leaf-dish"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "BC - 04 - Plaque",
              "code": 4,
              "x_coordinate": 0.640161,
              "y_coordinate": 0.55765,
              "objects": [
                {
                  "object": {
                    "id": "XRC04BEAABwjeK9F",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC04BEAABwjeK9F%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-24T11:32:51+0000",
                    "last_publication_date": "2019-06-27T04:33:48+0000",
                    "slugs": [
                      "bc---04---plaque---plaque"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "BC - 04 - Plaque - Plaque",
                      "name": "Plaque",
                      "subtitle": "<p>Small plaque with carved &#39;S&#39;, 1942-1948</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/25325"
                      },
                      "description": "<p>Woodworking and arts were consistently taught at Shingwauk. From 1940 to the 1960s woodworking projects included the creation of furniture as well as smaller handicraft items. These handicraft items were often sold at local Sault Ste. Marie events. This plaque is an example of one of the carved items that was made by Shingwauk students and sold locally.</p>",
                      "image": {
                        "dimensions": {
                          "width": 4164,
                          "height": 3456
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "5e288a2577ccba2e0050edb3914e8eda935a6246_2011-5_001_053_upload.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 943
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "f951e833a42af69186cf7e3ef1fbbd62bc077e57_2011-5_001_053_upload.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "point_of_interest": {
            "id": "XRC29hEAACIJeLck",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC29hEAACIJeLck%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-24T11:42:37+0000",
            "last_publication_date": "2019-07-16T01:59:01+0000",
            "slugs": [
              "bc---05---social-studies-notebook",
              "bc---04---plaque"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "BC - 05 - Social Studies Notebook",
              "code": 5,
              "x_coordinate": 0.357737,
              "y_coordinate": 0.684734,
              "objects": [
                {
                  "object": {
                    "id": "XRC1WBEAANwAeK_1",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC1WBEAANwAeK_1%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-24T11:34:56+0000",
                    "last_publication_date": "2019-06-27T04:34:31+0000",
                    "slugs": [
                      "bc---05---social-studies-notebook",
                      "bc-05---social-studies-notebook"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "BC - 05 - Social Studies Notebook",
                      "name": "Social Studies Notebook",
                      "subtitle": "<p>Sadie Oke’s Social Studies Notebook, ca. 1945</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/25261"
                      },
                      "description": "<p>The SRSC holds a range of student created items from the Shingwauk Residential School, including social studies and composition notebooks. Examining these notebooks provides a sense of the standardized lessons and type of curriculum the students were following.</p>",
                      "image": {
                        "dimensions": {
                          "width": 2979,
                          "height": 3690
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "87fb31f1e932afa02103ecda50de1cc0142fc67d_2010-024_001_019_001.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 1407
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "5d8e45c6f41b03bd9ab21627f77979a7ac0e2bf5_2010-024_001_019_001.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XRC1wxEAACQJeLGd",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC1wxEAACQJeLGd%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-24T11:36:37+0000",
                    "last_publication_date": "2019-06-27T04:35:38+0000",
                    "slugs": [
                      "bc---05---social-studies-notebook-interior-page-1"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "BC - 05 - Social Studies Notebook Interior page 1",
                      "name": "Social Studies Notebook Interior page 1",
                      "subtitle": "<p>Sadie Oke’s Social Studies Notebook, ca. 1945</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/25261"
                      },
                      "description": "<p>Social studies notebook page focused on houses.</p>",
                      "image": {
                        "dimensions": {
                          "width": 2939,
                          "height": 3676
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "2a08b18b971c0ac6948deb29c661cda4df1d1f26_2010-024_001_019_003.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 1421
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "1f1ae9df6947919b5318d0879cd823be53de70be_2010-024_001_019_003.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XRC10hEAACIJeLHq",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC10hEAACIJeLHq%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-24T11:37:26+0000",
                    "last_publication_date": "2019-06-27T04:35:59+0000",
                    "slugs": [
                      "bc---05---social-studies-notebook-interior-page-2",
                      "bc---05---social-studies-notebook-interior-page-1"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "BC - 05 - Social Studies Notebook Interior page 2",
                      "name": "Social Studies Notebook Interior page 2",
                      "subtitle": "<p>Sadie Oke’s Social Studies Notebook, ca. 1945</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/25261"
                      },
                      "description": "<p>Notebook page on houses and how they are constructed.</p>",
                      "image": {
                        "dimensions": {
                          "width": 2965,
                          "height": 3676
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "a058d9e18cf41cd6b88411f53f9740631824e78a_2010-024_001_019_004.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 1408
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "9ea22efcbc6ffd80ef6764548b00207550f20c29_2010-024_001_019_004.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XRC1_hEAABwjeLK7",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC1_hEAABwjeLK7%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-24T11:38:06+0000",
                    "last_publication_date": "2019-06-27T04:36:21+0000",
                    "slugs": [
                      "bc---05---social-studies-notebook-interior-page-3",
                      "bc---05---social-studies-notebook-interior-page-2"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "BC - 05 - Social Studies Notebook Interior page 3",
                      "name": "Social Studies Notebook Interior page 3",
                      "subtitle": "<p>Sadie Oke’s Social Studies Notebook, ca. 1945</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/25261"
                      },
                      "description": "<p>Drawing in Sadie Oke&#39;s Social Studies notebook.</p>",
                      "image": {
                        "dimensions": {
                          "width": 2965,
                          "height": 3690
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "dfba72a48a975077a5c25a00fabc6db57f382332_2010-024_001_019_009.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 1414
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "a43e81568d51ac4abb67f1a97623eacff2a48957_2010-024_001_019_009.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XRC2IhEAANwAeLNa",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC2IhEAANwAeLNa%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-24T11:38:25+0000",
                    "last_publication_date": "2019-06-27T04:36:38+0000",
                    "slugs": [
                      "bc---05---social-studies-notebook-interior-page-4",
                      "bc---05---social-studies-notebook-interior-page-3"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "BC - 05 - Social Studies Notebook Interior page 4",
                      "name": "Social Studies Notebook Interior page 4",
                      "subtitle": "<p>Sadie Oke’s Social Studies Notebook, ca. 1945</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/25261"
                      },
                      "description": "<p>Section of notebook that looks at the houses of Inuit peoples from a Euro-centric perspective.</p>",
                      "image": {
                        "dimensions": {
                          "width": 2965,
                          "height": 3462
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "e2caef534a127bc9d5a4720765abd466b2d37062_2010-024_001_019_010.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 1326
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "aad6c47e2afc5ba59cd692e39836b44de50ccf68_2010-024_001_019_010.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XRC2OREAANwAeLPL",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC2OREAANwAeLPL%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-24T11:38:54+0000",
                    "last_publication_date": "2019-06-27T04:36:53+0000",
                    "slugs": [
                      "bc---05---social-studies-notebook-interior-page-5",
                      "bc---05---social-studies-notebook-interior-page-4"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "BC - 05 - Social Studies Notebook Interior page 5",
                      "name": "Social Studies Notebook Interior page 5",
                      "subtitle": "<p>Sadie Oke’s Social Studies Notebook, ca. 1945</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/25261"
                      },
                      "description": "<p>Section of notebook that looks at the houses of Inuit peoples, includes a drawing of an igloo.</p>",
                      "image": {
                        "dimensions": {
                          "width": 2965,
                          "height": 3676
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "53cbf6f02b40acdb0e9ecdb815749cc4f75a8dca_2010-024_001_019_011.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 1408
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "17a33e9cc346e8831a3f8873df9d4586c1a3645f_2010-024_001_019_011.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        }
      ]
    }
  },
  {
    "id": "XQq_zRIAADpD1-3w",
    "uid": "printing-shop",
    "type": "kiosk",
    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq_zRIAADpD1-3w%22%29+%5D%5D",
    "tags": [],
    "first_publication_date": "2019-06-19T23:56:26+0000",
    "last_publication_date": "2019-06-27T08:36:05+0000",
    "slugs": [
      "printing-office",
      "printing-shop"
    ],
    "linked_documents": [],
    "lang": "en-ca",
    "alternate_languages": [],
    "data": {
      "title": "Printing Office",
      "description": "<p>Explore the digital object library to learn about the artifacts from the Shingwauk printing office.</p>",
      "zoomable": "No",
      "image_map": {
        "dimensions": {
          "width": 2704,
          "height": 3472
        },
        "alt": null,
        "copyright": null,
        "url": "7df12e1a28e1f376586813ab75d44eed9eccb0eb_image-map---printing-office.png"
      },
      "points_of_interest": [
        {
          "point_of_interest": {
            "id": "XRC3wREAACIJeLq9",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC3wREAACIJeLq9%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-24T11:49:52+0000",
            "last_publication_date": "2019-07-16T01:46:45+0000",
            "slugs": [
              "ps---01---algoma-missionary-news-and-shinguak-journal-title-plate-wood"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "PS - 01 - Algoma Missionary News and Shinguak Journal title plate (wood)",
              "code": 1,
              "x_coordinate": 0.367151,
              "y_coordinate": 0.321405,
              "objects": [
                {
                  "object": {
                    "id": "XRC4ThEAANwAeL1M",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC4ThEAANwAeL1M%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-24T11:47:29+0000",
                    "last_publication_date": "2019-06-27T04:37:28+0000",
                    "slugs": [
                      "ps---01---algoma-missionary-news-and-shingwauk-journal-title-plate-wood",
                      "ps---01---algoma-missionary-news-and-shinguak-journal-title-plate-wood"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "PS - 01 - Algoma Missionary News and Shingwauk Journal title plate (wood)",
                      "name": "Algoma Missionary News and Shingwauk Journal title plate (wood)",
                      "subtitle": "<p>Algoma Missionary News and Shingwauk Journal title plate (wood); ca. 1877</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/33507"
                      },
                      "description": "<p>In 1874, the Reverend E. F. Wilson, founder and first principal of Shingwauk, started printing the magazine Algoma Quarterly. Wilson acted as editor for the whole magazine, and writer of many of the articles. It was published under this title once every 3 months, and had missionary information for the Diocese of Algoma, including information about the Shingwauk Home. In 1877, the title was changed to Algoma Missionary News and Shingwauk Journal to reflect the focus on activities at the Shingwauk and Wawanosh Homes, and the fact that it was printed by students at Shingwauk. At this time the magazine began to be published monthly, and included more article submissions from missionaries around the Diocese. The main focus of the magazine was to inform the public about the various missionary activities going on in order to encourage financial support. Those who made regular donations to the Shingwauk home, as well as Algoma clergy, were given copies of the magazine gratis. Subscriptions were sold to others for 35 cents a year.</p><p>In 1878 an Anishinaabemowin supplement to the paper was published under the name of The Peace Pipe, &quot;an Ojibway newspaper published monthly at the Shingwauk Home.&quot; The subscription rate for this supplement was also 35 cents yearly. The magazine was intended to inform Indigenous people about the Shingwauk and Wawanosh Homes in order to encourage them to send their children. The Peace Pipe was short lived due to a lack of subscribers, but the Algoma Missionary News and Shingwauk Journal continued to be published on its own.</p><p>In 1884 the name was simplified to just Algoma Missionary News, which is the title that was used until publication ceased in 1956. At times during publication, the magazine carried advertising as well as news. Editors of the paper were clergymen, as follows: the Reverends E. F. Wilson, 1874-1889; G. H. Gaviller, 1889-1892; Charles Piercey, 1892-1918, Frederick W. Colloton, 1918-1944 and Frank F. Nock, 1944-1956.</p>",
                      "image": {
                        "dimensions": {
                          "width": 3190,
                          "height": 2037
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "86f7bd7132f3331c580403fc23d302269048f884_2014-030_002_007.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 725
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "49030b95fe13a48c34c8c5d5220eb28ad762a422_2014-030_002_007.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "point_of_interest": {
            "id": "XRC36xEAACIJeLt6",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC36xEAACIJeLt6%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-24T11:45:50+0000",
            "last_publication_date": "2019-07-16T01:48:28+0000",
            "slugs": [
              "ps---02---algoma-missionary-news-wood"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "PS - 02 - Algoma Missionary News (wood)",
              "code": 2,
              "x_coordinate": 0.630747,
              "y_coordinate": 0.469669,
              "objects": [
                {
                  "object": {
                    "id": "XRC4VREAANwAeL1u",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC4VREAANwAeL1u%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-24T11:48:36+0000",
                    "last_publication_date": "2019-06-27T06:06:54+0000",
                    "slugs": [
                      "ps---02---algoma-missionary-news-wood",
                      "ps---01---algoma-missionary-news-and-shinguak-journal-title-plate-wood"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "PS - 02 - Algoma Missionary News (wood)",
                      "name": "Algoma Missionary News and Shinguak Journal title plate (wood)",
                      "subtitle": "<p>Algoma Missionary News (wood); 1883    </p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/33508"
                      },
                      "description": "<p>From 1876 until 1883 Shingwauk operated its own print shop where students learned the trade by printing Algoma Missionary News and The Peace Pipe.</p><p>Four boys apprenticed in the shop, with two of them working at a time on alternate weeks. The two weeks they were not in the print shop were spent in class. Generally, they started their apprenticeship after being in the Institution for 2 years. The first four boys to work in the print shop were David McGrah age 13, William Sahguhcheway age 14, Willie Riley age 12, and John Rodd age 13.</p><p>When the shop first opened, there was no professional teacher to show the boys what to do, it was just Wilson who was also learning as he went along. The boys worked to fold and sew the papers for the magazine together, sometimes working long hours in order to get the issues out on time. The winter of 1877 was so cold that the boys had to work all through the night to finish printing otherwise the printing press and other equipment would freeze over.</p><p>The type originally used in the first small printing press, as well as the first AMN frontpiece from 1876, were carved in the carpentry shop by carpentry apprentice Adam Kiyoshk. In 1877 Wilson bought a more professional printing press and equipment from a local shop which was closing down. This allowed him to make Algoma Missionary News a monthly magazine of better quality. It also increased the students’ workload as they had to begin printing 1500-2000 issues every month instead of every two months. The printers had different holidays from the other students due to the year round requirements of their work.</p><p>In the summer of 1877 William Sahguhcheway and David McGrah were sent home for summer holidays early so that they would be at Shingwauk to print AMN while the other boys were away. The boys were given a small salary for their work, part of it given to them as money to pay for their board and part of it put into a Savings Account for them. This Savings money was inaccessible to the boys until they left the school at which point it was meant to be used to purchase the tools needed to continue working their trade. First year apprentice boys were paid $1/week and second year boys paid $2/week.</p>",
                      "image": {
                        "dimensions": {
                          "width": 3744,
                          "height": 1373
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "e7c1cd7aaeabc9b133600260c34c121e786daa7d_2014-030_002_008.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 417
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "92fc9d82000e9468b56c9d29caeff4f88065f2ea_2014-030_002_008.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "point_of_interest": {
            "id": "XRC38REAANwAeLud",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC38REAANwAeLud%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-24T11:46:07+0000",
            "last_publication_date": "2019-07-16T01:49:11+0000",
            "slugs": [
              "ps---03---algoma-missionary-news-woodalgoma-missionary-news-and-shingwauk-journal-title-plate-metal",
              "ps---03---algoma-missionary-news-wood",
              "ps---02---algoma-missionary-news-wood"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "PS - 03 - Algoma Missionary News (wood)\nAlgoma Missionary News and Shingwauk Journal title plate (metal)",
              "code": 3,
              "x_coordinate": 0.367151,
              "y_coordinate": 0.758866,
              "objects": [
                {
                  "object": {
                    "id": "XRC4nBEAACIJeL63",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XRC4nBEAACIJeL63%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-24T11:49:32+0000",
                    "last_publication_date": "2019-06-27T04:38:06+0000",
                    "slugs": [
                      "ps---03---algoma-missionary-news-and-shingwauk-journal-title-plate-metal",
                      "ps---02---algoma-missionary-news-wood"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "PS - 03 - Algoma Missionary News and Shingwauk Journal title plate (metal)",
                      "name": "Algoma Missionary News and Shingwauk Journal title plate (metal)",
                      "subtitle": "<p>Algoma Missionary News and Shingwauk Journal title plate (metal); 1880</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/33509"
                      },
                      "description": "<p>In 1878 Wilson bought a second larger Washington press and found a professional to teach the boys. Mr Reid rented out the shop and was paid a small salary to teach the boys to print AMN. Due to this added help, Wilson began to expand the work of the shop by publishing The Peace Pipe, a magazine written in both English and Ojibwe in addition to Algoma Missionary News. One of the more prominent students in the school, John Esquimau, was paid a small salary to edit this magazine. Unfortunately, The Peace Pipe only ran for a short time as Wilson could only find 200 subscribers rather than the 500 needed to not print the magazine at a loss. New boys were eventually brought into the trade as apprentice boys died (John Rodd) or switched to different trades (William Sahguhcheway and Willie Riley worked to be teachers). Other boys who worked in the print shop include Johnny Daniel who attended Shingwauk from 1875-1880, Joseph Kahgaug who attended from 1877-1882, Charlie McGrah who attended from 1875-1881, Fred Mookomaun who attended from 1877-1883, Fred Obotossaway who attended from 1875-1880, David Osahgee who attended from 1877-1886, Adam Pedahtig who attended from 1878-1884, Jack Rodd who attended from 1875-1879, and Pilate Rodd who attended from 1875-1882. The print shop closed sometime in 1882 or 1883 and AMN was published locally by Mr Biggings, who had temporarily taken on printing duties before. All the print stock, including the equipment, was sold in order to finance the new sash and door factory being created at Shingwauk. Once the work shifted permanently to Biggings, no more students were apprenticed and the trade ceased to be offered at the Institution.</p>",
                      "image": {
                        "dimensions": {
                          "width": 3888,
                          "height": 1517
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "1df98d17de163d0d905d92645ff729ee99037eb4_2014-030_002_009.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 443
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "88a08df9a363f18a25aa19a63673b76ed1adef07_2014-030_002_009.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        }
      ]
    }
  },
  {
    "id": "XQqu3BIAADpD16Ea",
    "uid": "residential-school",
    "type": "kiosk",
    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqu3BIAADpD16Ea%22%29+%5D%5D",
    "tags": [],
    "first_publication_date": "2019-06-19T23:57:08+0000",
    "last_publication_date": "2019-06-27T08:36:24+0000",
    "slugs": [
      "residential-school"
    ],
    "linked_documents": [],
    "lang": "en-ca",
    "alternate_languages": [],
    "data": {
      "title": "Residential School",
      "description": "<p>Explore locations within the Shingwauk Indian Residential School to learn more.</p>",
      "zoomable": "Yes",
      "image_map": {
        "dimensions": {
          "width": 2704,
          "height": 3472
        },
        "alt": null,
        "copyright": null,
        "url": "73f864bd6a6171e271f4366524fe8c55bd319688_image-map---residential-school.png"
      },
      "points_of_interest": [
        {
          "point_of_interest": {
            "id": "XQql4hIAAIFD13ix",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQql4hIAAIFD13ix%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-19T23:57:08+0000",
            "last_publication_date": "2019-07-16T01:27:01+0000",
            "slugs": [
              "rs---01---classrooms",
              "rs-01---classrooms",
              "residential-school-01---classrooms",
              "residential-school-01"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "RS - 01 - Classrooms",
              "code": 1,
              "x_coordinate": 0.707106,
              "y_coordinate": 0.450118,
              "objects": [
                {
                  "object": {
                    "id": "XQqmWhIAAKI313rK",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqmWhIAAKI313rK%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:58:02+0000",
                    "last_publication_date": "2019-06-27T04:40:49+0000",
                    "slugs": [
                      "rs---01---classrooms---junior-girls-class",
                      "rs---01---classrooms---classroom",
                      "rs-01---classrooms---classroom",
                      "residential-school-01---classrooms---classroom",
                      "residential-school-01---classroom",
                      "classroom"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 01 - Classrooms - Junior Girls Class",
                      "name": "Junior Girls Class",
                      "subtitle": "<p>Junior girls being read a story by their teacher, Miss McAuley. 1949.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/17012"
                      },
                      "description": "<p>An example of junior girls in the classroom.</p>",
                      "image": {
                        "dimensions": {
                          "width": 1544,
                          "height": 2205
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "36199066c89cf1fa12eb27aaf7fa294ab743a9c4_2010-015_001_006_006.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 1622
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "50ae41a08682a1a03df17a9d66e3f083a3f764d7_2010-015_001_006_006.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQqnNhIAAApF1375",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqnNhIAAApF1375%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:58:10+0000",
                    "last_publication_date": "2019-06-27T04:41:28+0000",
                    "slugs": [
                      "rs---01---classrooms---classroom",
                      "rs---01---classrooms---classroom-2",
                      "rs-01---classrooms---classroom-2",
                      "residential-school-01---classroom-2",
                      "residential-school-02---classroom",
                      "residential-school-01---classroom",
                      "asd",
                      "classroom"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 01 - Classrooms - Classroom",
                      "name": "Classroom",
                      "subtitle": "<p>Classroom at Shingwauk Residential School. 1936.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/15660"
                      },
                      "description": "<p>This is an example of one of the rooms that was used as a classroom at Shingwauk. Students at Shingwauk would have been seperated by age and gender while in classroom spaces.</p>",
                      "image": {
                        "dimensions": {
                          "width": 4096,
                          "height": 2789
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "f8dec6221230a2d74aa24571428c7bbd1ad766b2_2010-007_001_165.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 774
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "703e4589772e419d7e3fd17ba24c165a6b7fae3a_2010-007_001_165.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQqnmBIAANY014DG",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqnmBIAANY014DG%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:58:16+0000",
                    "last_publication_date": "2019-06-27T04:41:54+0000",
                    "slugs": [
                      "rs---01---classrooms---woodworking-classroom",
                      "rs-01---classrooms---woodworking-classroom",
                      "residential-school-01---classrooms---woodworking-classroom",
                      "residential-school-01---woodworking-classroom",
                      "woodworking-classroom"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 01 - Classrooms - Woodworking classroom",
                      "name": "Woodworking classroom",
                      "subtitle": "<p>Woodworking classroom set up for the day before students’ arrival. 1950.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/17027"
                      },
                      "description": "<p>Woodworking and arts were consistently taught at Shingwauk, with a seperate woodworking building being part of the Shingwauk facility for many years.</p>",
                      "image": {
                        "dimensions": {
                          "width": 4096,
                          "height": 2981
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "977e3e5de2063b4e323033f8fdb29f32e1b08ce3_2010-015_001_020_008.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 827
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "a050807f5f5dd702f08a87eedac1600a33087b05_2010-015_001_020_008.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQqnzRIAAKI314Gy",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqnzRIAAKI314Gy%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:58:47+0000",
                    "last_publication_date": "2019-06-27T04:42:20+0000",
                    "slugs": [
                      "rs---01---classrooms---first-aid-lesson",
                      "rs-01---classrooms---first-aid-lesson",
                      "residential-school-01---first-aid-lesson",
                      "first-aid-lesson"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 01 - Classrooms - First aid lesson",
                      "name": "First aid lesson",
                      "subtitle": "<p>Female students learning first aid. 1965.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/16776"
                      },
                      "description": "<p>Students learning first aid at Shingwauk.</p>",
                      "image": {
                        "dimensions": {
                          "width": 4096,
                          "height": 2893
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "314990fd6e91bc663c61c9596a99709f31baaa1a_2010-017_001_080_001.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 802
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "9024961b86029fac1da18b648222ae5c826af2aa_2010-017_001_080_001.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQqoThIAAApF14Pu",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqoThIAAApF14Pu%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:58:54+0000",
                    "last_publication_date": "2019-06-27T04:42:47+0000",
                    "slugs": [
                      "rs---01---classrooms---woodworking-lesson",
                      "rs---01---classrooms---woodworking-classroom-2",
                      "rs-01---classrooms---woodworking-classroom-2",
                      "residential-school-01---woodworking-classroom-2",
                      "woodworking-classroom"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 01 - Classrooms - Woodworking Lesson",
                      "name": "Woodworking Lesson",
                      "subtitle": "<p>Students being instructed in woodworking and carpentry. 1943.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/14801"
                      },
                      "description": "<p>Woodworking and arts were consistently taught at Shingwauk. From the 1940s to the 1960s woodworking projects included the creation of furniture as well as smaller handicraft items.</p>",
                      "image": {
                        "dimensions": {
                          "width": 4096,
                          "height": 2910
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "b4dea0f672a4496c0bc80d937bde57b1be7d06c4_2010-021_001_139_001.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 807
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "591f55e56239de8c45bed3c490630ded9562d50a_2010-021_001_139_001.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQqopBIAANY014Vr",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqopBIAANY014Vr%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:59:01+0000",
                    "last_publication_date": "2019-06-27T04:43:09+0000",
                    "slugs": [
                      "rs---01---classrooms---art-class",
                      "rs-01---classrooms---art-class",
                      "residential-school-01---art-class",
                      "art-class"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 01 - Classrooms - Art Class",
                      "name": "Art class",
                      "subtitle": "<p>Students in art class preparing for local art show. 1969.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/16698"
                      },
                      "description": "<p>In the later years of the Shingwauk School the programming changed to include more broad subjects, such as art.</p>",
                      "image": {
                        "dimensions": {
                          "width": 2358,
                          "height": 1830
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "634a367286643de960973ce0bd9a583b716d676c_2011-18_001_019_001.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 882
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "85114ed25aeeb9a0a206e57dcb3a2e89e7784f30_2011-18_001_019_001.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "point_of_interest": {
            "id": "XQqwRRIAAApF16eG",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqwRRIAAApF16eG%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-19T23:57:08+0000",
            "last_publication_date": "2019-07-16T01:29:05+0000",
            "slugs": [
              "rs---02---dining-room"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "RS - 02 - Dining Room",
              "code": 2,
              "x_coordinate": 0.496857,
              "y_coordinate": 0.68392,
              "objects": [
                {
                  "object": {
                    "id": "XQqwzRIAAKI316nc",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqwzRIAAKI316nc%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:59:07+0000",
                    "last_publication_date": "2019-06-27T04:44:30+0000",
                    "slugs": [
                      "rs---02---dining-room---dining-room"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 02 - Dining Room - Dining Room",
                      "name": "Dining Room",
                      "subtitle": "<p>Students eating a holiday meal. 1955.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/45474"
                      },
                      "description": "<p>Students and staff at Shingwauk ate in the same dining space, but were served very different meals. Students were fed meals consisting of very little meat and vegetables, where teachers were served meat with every meal.</p>",
                      "image": {
                        "dimensions": {
                          "width": 1416,
                          "height": 1016
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "e7edfce4a9eeda83a0f3355b0834e7b195287711_2010-009_001_021_003.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 815
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "b88babaffa17d9db1b5e06160646fc7fc0a27832_2010-009_001_021_003.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQqxIBIAANY016tO",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqxIBIAANY016tO%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:59:15+0000",
                    "last_publication_date": "2019-06-27T04:43:42+0000",
                    "slugs": [
                      "rs---02---dining-room---holiday-celebration",
                      "rs---02---dining-room---dining-room-2"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 02 - Dining Room - Holiday Celebration",
                      "name": "Holiday Celebration",
                      "subtitle": "<p>Dining room during holiday celebration. 1947.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/17012"
                      },
                      "description": "<p>This photograph shows Shingwauk girls serving tea to teachers and other adults as part of a special occasion at the Shingwauk.</p>",
                      "image": {
                        "dimensions": {
                          "width": 2211,
                          "height": 1507
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "8680e455ddc815d0b8320942b9638e80bf7d5ce8_2010-015_001_006_004.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 774
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "28cd8565f8975c2b7010cecb09f759f8974c86bd_2010-015_001_006_004.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "point_of_interest": {
            "id": "XQqyzhIAADpD17LQ",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqyzhIAADpD17LQ%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-19T23:57:08+0000",
            "last_publication_date": "2019-07-16T01:30:01+0000",
            "slugs": [
              "rs---03---dormitory"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "RS - 03 - Dormitory",
              "code": 3,
              "x_coordinate": 0.28347,
              "y_coordinate": 0.367025,
              "objects": [
                {
                  "object": {
                    "id": "XQqzYRIAAKI317Vl",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqzYRIAAKI317Vl%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:59:22+0000",
                    "last_publication_date": "2019-06-27T04:45:52+0000",
                    "slugs": [
                      "rs---03---dormitory---dormitory"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 03 - Dormitory - Dormitory",
                      "name": "Dormitory",
                      "subtitle": "<p>A dormitory at Shingwauk Residential School. 1936.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/15654"
                      },
                      "description": "<p>“It was very difficult for me to get used to having fifty of thirty girls in the same room as I was... the beds were okay but it was a small bed.” - Shingwauk Survivor, 1991 Reunion.</p><p>The dorms at Shingwauk were separated by gender, and there were different dormitory areas for boys and girls of the junior, intermediate, and senior ages. They would have been in extremely close quarters, with very little space between each bed. Students would mostly have only been in the dorms to sleep and get ready for the day.</p>",
                      "image": {
                        "dimensions": {
                          "width": 4096,
                          "height": 3308
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "9080a29917f1660033d14ad41df98e267fc64e7b_2010-007_001_159.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 917
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "1029fb02799b9fb0003f4eaf6b2b4dbef00093e2_2010-007_001_159.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQqztRIAADpD17bk",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqztRIAADpD17bk%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:59:30+0000",
                    "last_publication_date": "2019-06-27T04:46:25+0000",
                    "slugs": [
                      "rs---03---dormitory---junior-girls-dorm"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 03 - Dormitory - Junior girls dorm",
                      "name": "Junior girls dorm",
                      "subtitle": "<p>Junior girls getting ready for bed. 1956.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/16028"
                      },
                      "description": "<p>The dorms at Shingwauk were separated by gender, and there were different dormitory areas for boys and girls of the junior, intermediate, and senior ages. They would have been in extremely close quarters, with very little space between each bed. Students would mostly have only been in the dorms to sleep and get ready for the day.</p>",
                      "image": {
                        "dimensions": {
                          "width": 1215,
                          "height": 775
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "db361cddacb109a871b3623766309fbaf0a55b37_2010-009_001_018_002.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 725
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "090b6dedd1029de8835cd30c18259bfa35d00613_2010-009_001_018_002.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQqz9hIAAApF17gQ",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQqz9hIAAApF17gQ%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:59:52+0000",
                    "last_publication_date": "2019-06-27T04:47:22+0000",
                    "slugs": [
                      "rs---03---dormitory---junior-boys-dorm"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 03 - Dormitory - Junior boys dorm",
                      "name": "Junior boys dorm",
                      "subtitle": "<p>Junior boys saying prayers before bed. 1950.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/17012"
                      },
                      "description": "<p>Students at Shingwauk would have been required to participate in church services as well as daily prayers.</p>",
                      "image": {
                        "dimensions": {
                          "width": 2372,
                          "height": 1572
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "7426655775b60a1df8e98a71c90450e4e8d10e3b_2010-015_001_006_001.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 753
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "34962b7590bc2fea7ae3c8bf7062343c086ba183_2010-015_001_006_001.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQq1AhIAANY017zf",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq1AhIAANY017zf%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:59:45+0000",
                    "last_publication_date": "2019-06-27T04:48:01+0000",
                    "slugs": [
                      "rs---03---dormitory---junior-girls-relaxing",
                      "rs---03---dormitory---junior-girls-dorm-2"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 03 - Dormitory - Junior girls relaxing",
                      "name": "Junior girls relaxing",
                      "subtitle": "<p>Junior girls during free time in the dorm. 1967.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/16852"
                      },
                      "description": "<p>This photograph shows an example of the standard bedding and how the girls dormitory looked at Shingwauk.</p>",
                      "image": {
                        "dimensions": {
                          "width": 3659,
                          "height": 2587
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "64ce232e7bd46101b83a38e75c338b9ef90e768e_2010-017_001_021_001.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 803
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "a7487c6d8c19a8984c60977c915266c390429445_2010-017_001_021_001.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQq1NhIAAKI3173L",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq1NhIAAKI3173L%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:59:37+0000",
                    "last_publication_date": "2019-06-27T04:48:32+0000",
                    "slugs": [
                      "rs---03---dormitory---junior-boys-getting-ready",
                      "rs---03---dormitory---junior-boys-dorm2"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 03 - Dormitory - Junior boys getting ready",
                      "name": "Junior boys getting ready",
                      "subtitle": "<p>Boys getting ready for the day. 1962.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/20891"
                      },
                      "description": "<p>Each morning students were required to make their beds and clean up their small area in the dorm room.</p>",
                      "image": {
                        "dimensions": {
                          "width": 4096,
                          "height": 2919
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "f6825b6dee86fbe692b0e96df7cd5409f9d942d2_2010-031_001_003_001.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 810
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "35499d4b465566c93bcc3cf086fb553c6501797f_2010-031_001_003_001.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "point_of_interest": {
            "id": "XQq2IBIAAKI318Hj",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq2IBIAAKI318Hj%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-19T23:57:08+0000",
            "last_publication_date": "2019-07-16T01:30:50+0000",
            "slugs": [
              "rs---04---garden"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "RS - 04 - Garden",
              "code": 4,
              "x_coordinate": 0.400624,
              "y_coordinate": 0.52425,
              "objects": [
                {
                  "object": {
                    "id": "XQq2jhIAADpD18PY",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq2jhIAADpD18PY%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:59:58+0000",
                    "last_publication_date": "2019-06-27T04:50:16+0000",
                    "slugs": [
                      "rs---04---garden---garden"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 04 - Garden - Garden",
                      "name": "Garden",
                      "subtitle": "<p>View of the chapel behind the market garden. 1947.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/17017"
                      },
                      "description": "<p>Because Shingwauk operated on a half-day system, many students spent either the morning or afternoon working in the gardens and fields of the school. Their responsibilities ranged from tending to animals, to harvesting and taking care of the various crops grown on site.</p>",
                      "image": {
                        "dimensions": {
                          "width": 1733,
                          "height": 1029
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "96b704d6b6c1e1feef403f7f92c43650355f631c_2010-015_001_010_004.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 675
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "80e0208197e2324daea40526e4c7a853f812ca75_2010-015_001_010_004.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQq21BIAAFxJ18UY",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq21BIAAFxJ18UY%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-20T00:00:06+0000",
                    "last_publication_date": "2019-06-27T04:51:20+0000",
                    "slugs": [
                      "rs---04---garden---garden-view-from-the-school",
                      "rs---04---garden---garden-2"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 04 - Garden - Garden view from the school",
                      "name": "Garden view from the school",
                      "subtitle": "<p>View of garden from Shingwauk Hall. 1947.    </p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/17017"
                      },
                      "description": "<p>Front lawn of Shingwauk site as viewied from the main building.</p>",
                      "image": {
                        "dimensions": {
                          "width": 2685,
                          "height": 1830
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "db7896b40fdbdff2ac1af6b45daa913b43ca590a_2010-015_001_010_006.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 774
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "37fbe80954d430eeec9c9e69612956cd9d33493a_2010-015_001_010_006.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQq3GhIAAFpJ18Zf",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq3GhIAAFpJ18Zf%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:58:22+0000",
                    "last_publication_date": "2019-06-27T04:50:55+0000",
                    "slugs": [
                      "rs---04---garden---working-the-soil",
                      "rs---04---garden---garden-3"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 04 - Garden - Working the soil",
                      "name": "Working the soil",
                      "subtitle": "<p>Working around the grounds. 1947.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/17017"
                      },
                      "description": "<p>Students at Shingwauk did much of the manual labour at the School, including a lot of the farm and garden work.</p>",
                      "image": {
                        "dimensions": {
                          "width": 1961,
                          "height": 2897
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "e73f55c55350b45df0287a285d876e93d760b51e_2010-015_001_010_007.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 1678
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "f2e396ee96f8c6ffe66557ef7f01314003578551_2010-015_001_010_007.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQq3WRIAAFpJ18eL",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq3WRIAAFpJ18eL%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:58:28+0000",
                    "last_publication_date": "2019-06-27T04:51:46+0000",
                    "slugs": [
                      "rs---04---garden---farm-boys",
                      "rs---04---garden---garden-4"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 04 - Garden - Farm boys",
                      "name": "Farm boys",
                      "subtitle": "<p>Boys on the farm. 1946.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/14753"
                      },
                      "description": "<p>Students at Shingwauk did much of the manual labour at the School, including a lot of the farm and garden work. A portion of the food eaten at Shingwauk was grown on the site.</p>",
                      "image": {
                        "dimensions": {
                          "width": 4096,
                          "height": 2497
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "a7a894f572e4429c257cb82c9db9433322bc59fc_2010-021_001_089_001.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 693
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "803f83afe83995cf974ce21321b5725981e95d24_2010-021_001_089_001.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "point_of_interest": {
            "id": "XQq4lhIAANY0180v",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq4lhIAANY0180v%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-19T23:57:08+0000",
            "last_publication_date": "2019-07-16T01:31:21+0000",
            "slugs": [
              "rs---05---kitchen"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "RS - 05 - Kitchen",
              "code": 5,
              "x_coordinate": 0.374473,
              "y_coordinate": 0.77353,
              "objects": [
                {
                  "object": {
                    "id": "XQq5FhIAANY018-p",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq5FhIAANY018-p%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:58:33+0000",
                    "last_publication_date": "2019-06-27T04:55:21+0000",
                    "slugs": [
                      "rs---05---kitchen---kitchen"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 05 - Kitchen - Kitchen",
                      "name": "Kitchen",
                      "subtitle": "<p>Boys cutting potatoes into buckets. 1945.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/20894"
                      },
                      "description": "<p>“I don’t like cabbage. I hate it when it’s boiled. My friends and I would not eat the boiled cabbage. We were told there would be no dessert if we did not eat all our food. So we put it in our apron pockets. After the meal, we went directly to the girls’ washroom and flushed our cabbage that was in our apron pockets.” - Shingwauk Survivor, 1991 Reunion</p><p>Students, often female, worked in the kitchen helping to prepare meals and to clean up afterwards.</p>",
                      "image": {
                        "dimensions": {
                          "width": 4096,
                          "height": 2896
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "15d82c2ffe3265654ed6148b1b17cb50041ebc57_2010-021_001_063_001-ch-edited.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 803
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "d5bb5872862603d0d36b8d604539d03c0a8471c5_2010-021_001_063_001-ch-edited.jpg"
                        }
                      }
                    }
                  }
                },
                {
                  "object": {
                    "id": "XQq5dRIAAMhJ19FY",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq5dRIAAMhJ19FY%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-19T23:58:40+0000",
                    "last_publication_date": "2019-06-27T04:55:35+0000",
                    "slugs": [
                      "rs---05---kitchen---girls-cleaning",
                      "rs---05---kitchen---kitchen-2"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 05 - Kitchen - Girls Cleaning",
                      "name": "Girls cleaning",
                      "subtitle": "<p>Girls cleaning the kitchen. 1968.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/20894"
                      },
                      "description": "<p>Students, often female, worked in the kitchen helping to prepare meals and to clean up afterwards.</p>",
                      "image": {
                        "dimensions": {
                          "width": 4096,
                          "height": 2919
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "1b854b3de269c15aef313ece71a640cf065cef29_2010-031_001_006_001.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 810
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "ae878e488a4e56f06db2122b4d061a9c67b778af_2010-031_001_006_001.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "point_of_interest": {
            "id": "XQq5-RIAANY019Oj",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq5-RIAANY019Oj%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-19T23:57:08+0000",
            "last_publication_date": "2019-07-16T01:32:10+0000",
            "slugs": [
              "rs---06---laundry"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "RS - 06 - Laundry",
              "code": 6,
              "x_coordinate": 0.647483,
              "y_coordinate": 0.776788,
              "objects": [
                {
                  "object": {
                    "id": "XQq6pBIAANY019bU",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq6pBIAANY019bU%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-20T00:00:18+0000",
                    "last_publication_date": "2019-06-27T04:59:47+0000",
                    "slugs": [
                      "rs---06---laundry---laundry"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 06 - Laundry - Laundry",
                      "name": "Laundry",
                      "subtitle": "<p>Students working in the laundry. 1956.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/16028"
                      },
                      "description": "<p>“The second job I had was ironing a week&#39;s load of laundry - I forget the lady&#39;s name - when I was finished I would go meet my friends downtown for movies or supper.” - Irene Barbeau</p><p>Laundry at Shingwauk would have been done by the female students at the school. They were tasked with both the washing and mending of clothing of both staff and students.</p>",
                      "image": {
                        "dimensions": {
                          "width": 1400,
                          "height": 1419
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "bbea0d51050c17c2f194db919f32b6d6a01b9788_2010-009_001_018_001-ch-edited.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 1151
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "6e8deca537003b1bf918a5b188cfe09be578246c_2010-009_001_018_001-ch-edited.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "point_of_interest": {
            "id": "XQq7HhIAAMhJ19kP",
            "uid": null,
            "type": "point_of_interest",
            "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq7HhIAAMhJ19kP%22%29+%5D%5D",
            "tags": [],
            "first_publication_date": "2019-06-19T23:57:08+0000",
            "last_publication_date": "2019-07-16T01:32:42+0000",
            "slugs": [
              "rs---07---sewing-room"
            ],
            "linked_documents": [],
            "lang": "en-ca",
            "alternate_languages": [],
            "data": {
              "name": "RS - 07 - Sewing Room",
              "code": 7,
              "x_coordinate": 0.172592,
              "y_coordinate": 0.771901,
              "objects": [
                {
                  "object": {
                    "id": "XQq6_hIAAFxJ19h5",
                    "uid": null,
                    "type": "object",
                    "href": "https://shingwauk-kiosk-2019.cdn.prismic.io/api/v2/documents/search?ref=XS0vZRAAAGcbD5l0&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22XQq6_hIAAFxJ19h5%22%29+%5D%5D",
                    "tags": [],
                    "first_publication_date": "2019-06-20T00:00:26+0000",
                    "last_publication_date": "2019-06-27T05:12:50+0000",
                    "slugs": [
                      "rs---07---sewing-room---sewing-room"
                    ],
                    "linked_documents": [],
                    "lang": "en-ca",
                    "alternate_languages": [],
                    "data": {
                      "id": "RS - 07 - Sewing Room - Sewing Room",
                      "name": "Sewing Room",
                      "subtitle": "<p>Mrs. Clarkson in the sewing room. 1948.</p>",
                      "link": {
                        "link_type": "Web",
                        "url": "http://archives.algomau.ca/main/?q=node/14627"
                      },
                      "description": "<p>Students, often female, worked in the laundry and sewing room helping to mend and clean clothing.</p>",
                      "image": {
                        "dimensions": {
                          "width": 4096,
                          "height": 2710
                        },
                        "alt": null,
                        "copyright": null,
                        "url": "6be8512235fc0ea85b1d8eaafd8d69c043ec8ff3_2010-021_001_032_001ch-edited.jpg",
                        "thumb": {
                          "dimensions": {
                            "width": 1136,
                            "height": 752
                          },
                          "alt": null,
                          "copyright": null,
                          "url": "f6c9df28bebdd500c6df3c82a15e2d05c9cd040d_2010-021_001_032_001ch-edited.jpg"
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        }
      ]
    }
  }
];